<template>
  <v-row no-gutters>
    <v-col cols="12">
      <v-autocomplete
        :chips="chips"
        :clearable="clearable && !readonly"
        :disabled="disabled"
        :error-messages="selectValidation"
        :filter="noFilter"
        :items="items"
        :label="label"
        :loading="loading"
        :menu-props="menuProps"
        :multiple="multiple"
        :placeholder="placeholder"
        :rules="rules"
        :search-input.sync="search"
        v-model="select"
        :readonly="readonly"
        validate-on-blur
      >
        <template slot="no-data">
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>
                {{ $t("components.locationAjaxSelect.noData") }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
        <template slot="item" slot-scope="data">
          <v-list-item-content>
            <v-list-item-title v-html="data.item.text" />
          </v-list-item-content>
        </template>
      </v-autocomplete>
    </v-col>
  </v-row>
</template>

<script>
import "lodash";

export default {
  name: "LocationAjaxSelectMultiple",
  props: {
    rules: {
      required: false,
      default: () => []
    },
    readonly: {
      required: false,
      default: false
    },
    selectModel: {
      required: true
    },
    selectText: {
      required: false,
      default: ""
    },
    label: {
      type: String,
      required: false,
      default: "Wybierz wartość"
    },
    clearable: {
      type: Boolean,
      required: false,
      default: true
    },
    selectValidation: {
      type: Array,
      required: false,
      default: () => []
    },
    onChange: {
      type: Function,
      default: function(/*val*/) {}
    },
    placeholder: {
      type: String,
      default: function() {
        return null;
      }
    },
    defaultItems: {
      default: () => []
    },
    onSearch: {
      type: Function,
      required: false,
      // eslint-disable-next-line no-undef
      default: _.debounce(function(searchText, object) {
        let newItems = object.items;
        object.loading = true;
        this.axios({
          url: "location/search",
          data: { q: searchText },
          method: "POST"
        }).then(resp => {
          for (let index in resp.data) {
            newItems.push({
              value: resp.data[index].id,
              text: resp.data[index].text
            });
            this.$store.commit("Location/addLocation", {
              value: resp.data[index].id,
              text: resp.data[index].text
            });
            object.items = newItems;
          }
          this.$store.commit("Location/saveToLocalStorage");
          object.loading = false;
        });
      }, 300)
    },
    onInitFunction: {
      type: Function,
      default: function() {
        return this.defaultItems;
      }
    },
    multiple: {
      type: Boolean,
      required: false,
      default: false
    },
    chips: {
      type: Boolean,
      required: false,
      default: false
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    availableItems: {
      required: false,
      default: () => []
    }
  },
  data: () => ({
    dateDialog: false,
    timeDialog: false,
    model: "",
    validationError: false,
    validationMessage: [],
    contextItems: [],
    search: "",
    loading: false,
    menuProps: {
      closeOnClick: false,
      closeOnContentClick: false,
      openOnClick: false,
      maxHeight: 300
    }
  }),
  watch: {
    search(val) {
      val && this.onSearch(val, this);
    },
    selectModel(val) {
      this.downloadMissingLocations();
      this.onChange(val);
    },
    items(val) {
      this.$emit("update:availableItems", val);
    }
  },
  computed: {
    select: {
      set: function(value) {
        this.search = "";
        this.$emit("update:selectModel", value);
        if (typeof this.items.find(item => item.value === value) === "undefined") {
          this.$emit("update:selectText", "");
        } else {
          this.$emit("update:selectText", this.items.find(item => item.value === value).text);
        }
      },
      get: function() {
        return this.selectModel;
      }
    },
    items: {
      set(selectItems) {
        this.contextItems = selectItems.filter(selectItem => this.defaultItems.findIndex(defaultItem => defaultItem.value === selectItem.value) === -1);
      },
      get() {
        let result = this.defaultItems;
        result = result.concat(this.contextItems);
        return result.concat(this.contextItems);
      }
    }
  },
  methods: {
    filter(/*item, queryText, itemText*/) {},
    noFilter(item /*, queryText, itemText*/) {
      return item;
    },
    downloadMissingLocations() {
      for (let locationId of this.selectModel) {
        this.$store.dispatch("Location/getLocation", { placeId: locationId }).then(location => {
          this.contextItems.push({ value: location.id, text: location.text });
        });
      }
    }
  },
  created() {
    this.items = this.onInitFunction();
    this.downloadMissingLocations();
  }
};
</script>

<style scoped></style>
